import {
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuProps,
  MenuTrigger
} from "@fluentui/react-components";
import React, { useState } from "react";

import {
  AppsListDetail24Filled,
} from "@fluentui/react-icons";
import GemLayout from "../BudgetTracking/GemLayout";
import { IFinOpsBudgetAllocationCombined } from "../../../models/FinOpsBudgets";
import { Pages } from "../../../models/Nav";
import { useNavigate } from "react-router-dom";

const GEMDrillDownMenu: React.FC<{
  gems: string[];
  data: IFinOpsBudgetAllocationCombined[];
  onGEMDrilldownSelect: (selection: { gem: string }) => void;
}> = ({ gems, data, onGEMDrilldownSelect }) => {

  const [open, setOpen] = React.useState(false);
  const [selected, setSelected] = useState<{ category: string; type: string } | null>(null);
  
  const onOpenChange: MenuProps["onOpenChange"] = (e, data) => {
    setOpen(data.open);
  };

  const handleDrillDownSelect = (gem: string) => {
        onGEMDrilldownSelect?.({ gem });
    };

  return (
    <Menu open={open} onOpenChange={onOpenChange}>
      <MenuTrigger disableButtonEnhancement>
        <MenuButton appearance="primary" icon={<AppsListDetail24Filled />}>
          Drill Down
        </MenuButton>
      </MenuTrigger>

      <MenuPopover>
        <MenuList>
          {gems.map((gemId) => (
            <MenuItem
              key={gemId}
              onClick={() => handleDrillDownSelect(gemId)}
            >
              {gemId}
            </MenuItem>
          ))}
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};

export default GEMDrillDownMenu;
